export default __webpack_public_path__ + "static/insta-hotels-2-7205327550f861fee466f75e0a0c5723.jpg";